// epochs
export type LockPeriod = 2n | 3n | 4n | 6n;
export const LOCK_PERIODS = [2n, 3n, 4n, 6n] as LockPeriod[];
